<template>
  <div>
    <div class="details-header">
        <h2>Je gegevens</h2>
        <router-link class="button--secondary" to="/">Gegevens aanpassen</router-link>
    </div>
    <div class="details-form">
        <div class="details-question">
            <label class="calculator__label calculator__label--small">Aanhef<span class="required-icon">*</span></label>
            <div class="details-form-radio">
                <div class="form__radio-group">
                    <div class="form__radio">
                        <input type="radio" name="salutation" v-model="salutation" value="Dhr." class="form__input" required checked="checked">
                        <span>
                            <div class="custom_radio"></div>
                            <label for="aanhef">Dhr.</label>
                        </span>
                    </div>
                    <div class="form__radio">
                        <input type="radio" name="salutation" v-model="salutation" value="Mevr." class="form__input" required>
                        <span>
                            <div class="custom_radio"></div>
                            <label for="aanhef">Mevr.</label>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="details-question">
            <div class="details-question-columns">
              <div class="details-question-column">
                <label class="calculator__label calculator__label--small" for="first_name">Voornaam<span class="required-icon">*</span></label>
                <input type="text" v-on:input="firstNameInputChanged" :value="first_name" id="first_name" name="first_name" class="form__input" required>
              </div>
              <div class="details-question-column">
                <label class="calculator__label calculator__label--small" for="last_name">Achternaam<span class="required-icon">*</span></label>
                <input type="text" v-on:input="lastNameInputChanged" :value="last_name" id="last_name" class="form__input" required>
              </div>
            </div>
        </div>
        <div class="details-question">
            <div class="details-question-columns">
                <div class="details-question-column">
                  <label class="calculator__label calculator__label--small" for="company_name">Bedrijfsnaam<span class="required-icon">*</span></label>
                  <input type="text" v-on:input="companyNameInputChanged" :value="company_name" id="company_name" class="form__input" required>
                </div>
                <div class="details-question-column">
                  <label class="calculator__label calculator__label--small" for="branche">Branche<span class="required-icon">*</span></label>
                  <div class="form__select">
                    <select v-on:change="brancheInputChanged" name="branche" id="branche" :value="branche" required>
                      <option value="">Kies een branche</option>
                      <option value="Adviesbureaus">
                        Adviesbureaus
                      </option>
                      <option value="Agrarisch, land en tuinbouw">
                        Agrarisch, land en tuinbouw
                      </option>
                      <option value="Automotive">
                        Automotive
                      </option>
                      <option value="Bouw">
                        Bouw
                      </option>
                      <option value="Communicatie, marketing en reclame">
                        Communicatie, marketing en reclame
                      </option>
                      <option value="Detailhandel">
                        Detailhandel
                      </option>
                      <option value="Drukkerij">
                        Drukkerij
                      </option>
                      <option value="Energie en installatiebedrijven">
                        Energie en installatiebedrijven
                      </option>
                      <option value="Financiele en juridische dienstverlening">
                        Financiele en juridische dienstverlening
                      </option>
                      <option value="Groothandel">
                        Groothandel
                      </option>
                      <option value="Horeca, recreatie en sport">
                        Horeca, recreatie en sport
                      </option>
                      <option value="ICT en telecom">
                        ICT en telecom
                      </option>
                      <option value="Onderwijs en opleidingen">
                        Onderwijs en opleidingen
                      </option>
                      <option value="Overheid">
                        Overheid
                      </option>
                      <option value="Techniek, industrie en productie">
                        Techniek, industrie en productie
                      </option>
                      <option value="Transport, logistiek en warehousing">
                        Transport, logistiek en warehousing
                      </option>
                      <option value="Vastgoed">
                        Vastgoed
                      </option>
                      <option value="Zorg">
                        Zorg
                      </option>
                      <option value="Overig">
                        Overig
                      </option>
                    </select>
                  </div>
                </div>
            </div>
        </div>
        <div class="details-question">
            <div class="details-question-columns">
                <div class="details-question-column">
                  <label class="calculator__label calculator__label--small" for="email">Zakelijk emailadres<span class="required-icon">*</span></label>
                  <input type="email" v-on:input="emailInputChanged" :value="email" id="email" class="form__input" required>
                </div>
                <div class="details-question-column">
                  <label class="calculator__label calculator__label--small" for="phone">Telefoonnummer<span class="required-icon">*</span></label>
                  <input type="tel" minlength="10" pattern="^[0-9-+s()]*$" v-on:input="phoneInputChanged" :value="phone" id="phone" class="form__input" required>
                </div>
            </div>
        </div>
    </div>
    <div class="details-call-to-action">
        <div class="call-to-action-privacy">Je gaat er mee akkoord dat wij bovenstaande gegevens verzamelen en opslaan. Wij gebruiken deze gegevens om jou extra informatie over zakelijke zonnepanelen te sturen. Voor meer informatie bekijk <a href="https://www.zonnestroomnederland.nl/privacy-en-cookieverklaring/">onze privacyverklaring</a>.</div>
        <router-link to="/result/" class="button--main" v-bind:class="{ 'is--disabled': !this.$store.getters.detailsFormValid }">Bekijk direct hoeveel je kan verdienen</router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Details',
  computed: {
    salutation: {
      get () {
        return this.$store.state.variables.salutation
      },
      set (value) {
        this.$store.commit('setSalutation', value)
      }
    },
    first_name () {
      return this.$store.state.variables.first_name
    },
    last_name () {
      return this.$store.state.variables.last_name
    },
    company_name () {
      return this.$store.state.variables.company_name
    },
    branche () {
      return this.$store.state.variables.branche
    },
    email () {
      return this.$store.state.variables.email
    },
    phone () {
      return this.$store.state.variables.phone
    }
  },
  methods: {
    firstNameInputChanged (e) {
      this.$store.commit('setFirstName', e.target.value)
    },
    lastNameInputChanged (e) {
      this.$store.commit('setLastName', e.target.value)
    },
    companyNameInputChanged (e) {
      this.$store.commit('setCompanyName', e.target.value)
    },
    emailInputChanged (e) {
      this.$store.commit('setEmail', e.target.value)
    },
    phoneInputChanged (e) {
      this.$store.commit('setPhone', e.target.value)
    },
    brancheInputChanged (e) {
      this.$store.commit('setBranche', e.target.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Details.vue